{
  "version": "0.2.0",
  "gitCommitHash": "9417dcf2d2618eb5aab5728172ce5f7b159164bb",
  "gitCommitShortHash": "9417dcf",
  "gitBranch": "HEAD",
  "gitTags": "",
  "clean": true
}